import Vue from 'vue';
import Vuex from 'vuex';
import User from '@/models/User';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    modules: [
      { title: 'Хелпдеск', route: 'helpdesk', icon: 'lifebuoy' },
      { title: 'Задачи', route: 'team', icon: 'wrench' },
      { title: 'Статистика', route: 'stat', icon: 'chart-areaspline' },
      { title: 'Платформы', route: 'platforms', icon: 'cube' },
      { title: 'Пользователи', route: 'users', icon: 'account-multiple' },
      { title: 'CRON', route: 'cron', icon: 'clock-outline' },
      { title: 'Справочники', route: 'handbooks', icon: 'format-list-bulleted' },
    ],
  },

  getters: {
    user({ user }) {
      return user ? new User(user) : null;
    },
    modules: ({ modules }, { user }) => {
      return modules.filter(({ route }) => user.can(route));
    },
  },
  mutations: {
    setUser(state, payload = null) {
      state.user = payload;
    },
  },
  actions: {},
});
